<script setup>
import { maskName ,exchangeRate} from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
import {  setCollectApi, setDelCollectApi } from '@/apis/detail'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const userStore = useUserStore()
const props = defineProps({
    goods: {
        type: Object,
        default: () => { }
    }

})
/**
 * 
 * @param id 收藏
 */
const setCollect = async (id) => {
    if (userStore.userInfo.token) {
        const res = await setCollectApi({ productId: id })
        if (res.code == 0) {
            props.goods.isCollection = 2
            ElMessage({ type: 'success', message: t('home30') })
            userStore.getUser()
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    } else {
        // 2. 跳转到登录页
        // routers.push('/login')
    }
}
/**
 * 
 * @param id 取消收藏
 */
const setDelCollect = async (id) => {
    const res = await setDelCollectApi({ productId: id })
    if (res.code == 0) {
        props.goods.isCollection = 1
        ElMessage({ type: 'success', message: t('home31') })
        userStore.getUser()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

</script>
<template>
     <div class="goods-item">
        <div class="item-content">
            <RouterLink :to="`/detail/${goods.id}`">
                <div class="image-container">
                    <img :src="goods.images[0]" alt="">
                    <div class="icon">
                            <svg-icon icon-class="shoppingbag" style="width: 30px;height: 30px;" />
                        </div>
                </div>
                <p class="name">{{ goods.name }}</p>
                <!-- <p class="desc ellipsis">{{ goods.description }}</p> -->
            </RouterLink>
                <div class="price">
                    <div>
                        <span v-if="userStore.exchangeRate.symbol== '￥'">¥ {{ goods.price }}</span>
                        <span v-else> {{ exchangeRate(goods.price,userStore.exchangeRate.symbol,userStore.exchangeRate.rate) }}</span>
                    </div>
                    <div>
                        <div @click="setCollect(goods.id)" class="nocollect"
                            v-if="goods.isCollection == 1 || goods.isCollection == 0">
                            <i class="iconfont icon-favorite-filling" ></i>
                        </div>
                        <div @click="setDelCollect(goods.id)" v-if="goods.isCollection == 2" class="collect">
                            <i class="iconfont icon-favorite-filling"></i>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <!-- </RouterLink> -->
</template>

<style scoped lang="scss">
.nocollect {
    color: #b9b4b4;
}

.collect {
    color: #e26237;
}

.goods-item {
    // background: #ffffff;
    // border-radius: 8px;
    // // box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .1);
    // transition: box-shadow .2s linear;
    // border-color: transparent;
    // display: block;
    // width: 267px;
    width: 210px;
    height:325px;
    // background: #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
    transition: border 0.3s;
    border: 1px solid transparent;
    // padding: 20px 30px;
    // text-align: center;
    // transition: all .5s;
    // margin-bottom: 20px;
    // padding-bottom: 20px;

    &:hover {
        // transform: translate3d(0, -3px, 0);
        // box-shadow: 0 3px 8px rgb(0 0 0 / 20%);
        // border-radius: 10px;
        // width: 240px;
        // height: 366px;
        border-radius: 8px;
        border: 1px solid #FC3938;
    }
    .item-content{
        display: flex;
        justify-content: center;
        padding: 6px;
        flex-direction: column;
    }
    .image-container {
        // display: flex;
        // justify-content: center;
        // /* 水平居中 */
        // align-items: center;
        // /* 垂直居中 */
        // overflow: hidden;
        /* 截取多余的部分 */
        width: 198px;
        height: 198px;
        overflow: hidden;
        /* 如果图片超出容器大小，这将确保图片被截取而不是溢出 */
        position: relative;

        /* 设置容器高度 */
        img {
            // border-radius: 10px;
            width: 100%;
            /* 图片宽度设置为容器宽度的100% */
            height: 100%;
            object-fit: cover;
            /* 最大高度不超过容器高度 */
            border-radius: 8px;
        }
        .icon {
                    position: absolute;
                    right: 8px;
                    bottom: 10px;
                }
    }

    // .image-container img {
    //     width: 100%;
    //     /* 图片宽度设置为容器宽度的100% */
    //     height: 100%;
    //     object-fit: cover;
    //     /* 最大高度不超过容器高度 */
    // }

    // img {
    //     width: 220px;
    //     height: 293px;
    //     border-radius: 10px;
    // }

    p {
        // padding: 3px 10px;
        text-align: left;
    }

    .name {
        margin-top: 16px;
        margin-bottom: 19px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #11192D;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        width: 200px;
        height: 42px;
        /* 添加以下属性 */
        overflow: hidden; /* 隐藏超出部分 */
        display: -webkit-box; /* 使用 WebKit 的盒模型 */
        -webkit-line-clamp: 2; /* 限制显示的行数为 2 行 */
        -webkit-box-orient: vertical; /* 垂直排列 */
    }

    .desc {
        color: #999;
        height: 29px;
    }

    .price {
        display: flex;
        justify-content: space-between;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #11192D;
        line-height: 19px;
        text-align: left;
        font-style: normal;

        // .unit {
        //     font-weight: bold;
        //     font-size: 12px;
        //     height: 15px;
        //     line-height: 15px;
        //     position: relative;
        //     top: -1px;
        //     color: #ff4f24;
        //     font-family: xianyubeta, sans-serif;
        // }
    }

    .user {
        display: flex;
        align-items: center;
        padding: 0px 10px 0 10px;

        .avatar {
            width: 20px;
            /* 设置头像的宽度 */
            height: 20px;
            /* 设置头像的高度 */
            border-radius: 50%;
            /* 使头像呈现圆形 */
        }

        .username {
            margin-left: 4px;
            font-size: 12px;
        }
    }
}

@media (max-width: 768px) {
    .container {
        width: 100%;
    }

    .goods-item {
        // border: 1px solid;
        // flex: 1 1 calc(50% - 5px);
        // /* 每个商品项占50%宽度，减去间隙 */
        // max-width: calc(50% - 5px);
        background-color: white;
        // border: 1px solid #ccc;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
        // padding: 10px;
        margin-bottom: 10px;
        height: 100%;
        width: 100%;
        &:hover{
            border: 1px solid transparent;
        }
        .image-container {
            width: 100%;
            height: 222px;
            // border: 1px solid;
        }

        img {
            width: 100%;
            /* 图片自适应父容器宽度 */
            height: auto;
            /* 保持图片比例 */
            border-bottom: 1px solid #eee;
        }
        .item-content{
        display: flex;
        justify-content: center;
        padding: 0px;
        flex-direction: column;
    }
        .name {
            margin-top: 10px;
            margin-bottom: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            width: 167px;
            height: 38px;
            /* 添加以下属性 */
            overflow: hidden; /* 隐藏超出部分 */
            display: -webkit-box; /* 使用 WebKit 的盒模型 */
            -webkit-line-clamp: 2; /* 限制显示的行数为 2 行 */
            -webkit-box-orient: vertical; /* 垂直排列 */
        }
        p {
            font-size: 15px;
            padding: 3px 10px;
            text-align: left;
        }

        .price {
            font-size: 15px;

            .unit {
                font-weight: bold;
                font-size: 14px;
                height: 15px;
                line-height: 15px;
                position: relative;
                top: -1px;
                color: #ff4f24;
                font-family: xianyubeta, sans-serif;
            }
        }
    }
}
</style>